var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_16_1612",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_16_1612)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_16_1612",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 6,
    height: 6,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 6,
    height: 6,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 4,
    mask: "url(#path-2-inside-2_16_1612)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_16_1612",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 6,
    height: 6,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 6,
    height: 6,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 4,
    mask: "url(#path-3-inside-3_16_1612)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_16_1612",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 6,
    height: 6,
    rx: 1
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 6,
    height: 6,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 4,
    mask: "url(#path-4-inside-4_16_1612)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/board.f2fe2d949ebdd8f25fe084e70d691974.svg";
export { ForwardRef as ReactComponent };